import { Alert, Button, Col, DatePicker, Divider, message, Modal, Progress, Row, Spin, Table, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { templateShiftExcel } from '../../Utils/exportShiftExcel';
const { RangePicker } = DatePicker;

function UserShift() {
    const token = useSelector((state) => state.user.token);
    const [dates, setDates] = useState(moment().format('YYYY-MM-DD'));
    const [data, setData] = useState([]);
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [fileList, setFileList] = useState([]);

    const [rangeDate, setRangeDate] = useState([]);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [remainingTime, setRemainingTime] = useState(0);

    const titlePage = 'Data Shift Karyawan';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Employee Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => record.users?.users_code || "-"
        },
        {
            title: 'Employee Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.users?.name || "-"
        },
        {
            title: 'Shift',
            dataIndex: 'tgl',
            key: "tgl",
            render: (text, record) => record.shift?.name || "-"
        },
        {
            title: 'Date',
            dataIndex: 'tgl',
            key: "tgl",
            render: (text, record) => record.date ? moment(record.date).format('DD-MM-YYYY') : "-"
        },
        {
            title: 'Clock In',
            dataIndex: 'clockin',
            key: "clockin",
            render: (text, record) => record.shift?.time_in || "-"
        },
        {
            title: 'Clock Out',
            dataIndex: 'clockout',
            key: "clockout",
            render: (text, record) => record.shift?.time_out || "-"
        },
    ];

    const handleExcelFileRead = async (file) => {
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data);
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const totalRows = jsonData.length - 1;
        const totalCols = jsonData[0]?.length || 1;
        const estimatedSeconds = Math.ceil(totalRows * totalCols * 0.2);
        setTotalRows(totalRows > 0 ? totalRows : 1);
        setRemainingTime(estimatedSeconds);
        return { totalRows, estimatedSeconds };
    };

    useEffect(() => {
        getApi("GET", '/usershift?date=' + dates + '&search=' + search + '&page=' + page.pagination.current, 'usershift');
        if (users.length === 0) getApi("GET", '/users?nopage=true', 'users');
    }, [JSON.stringify(page), isAlert, dates]);

    const getApi = (method, url, type) => {
        setLoading(true);
        apiCall({ method, url, data: { headers: { Authorization: 'Bearer ' + token } } })
            .then((res) => {
                if (res.status === "success") {
                    if (type === 'usershift') {
                        setData(res.data.data);
                        setPage({ ...page, pagination: { ...page.pagination, total: res.data.total_data } });
                    } else if (type === 'users') {
                        setUsers(res.data.data);
                    }
                }
            })
            .catch((e) => console.log(e.message))
            .finally(() => setLoading(false));
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, ...sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) setData([]);
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({ pagination: { current: 1, pageSize: 10 } });
    };

    const closeModal = () => setIsModal(false);

    const props = {
        onRemove: file => setFileList(prev => prev.filter(item => item.uid !== file.uid)),
        beforeUpload: file => {
            setFileList([file]);
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                const totalRows = jsonData.length - 1;
                const totalCols = jsonData[0]?.length || 1;
                const estimatedSeconds = Math.ceil(totalRows * totalCols * 0.2);
                setTotalRows(totalRows > 0 ? totalRows : 1);
                setRemainingTime(estimatedSeconds);
            };
            reader.readAsArrayBuffer(file);
            return false;
        },
        fileList,
    };

    const postUpload = (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        return apiCall({
            method,
            url,
            data: {
                data: values,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        })
            .then((res) => {
                message[res.status === "success" ? 'success' : 'error'](res.message);
                setTextAlert(res.message);
                setIsAlert(true);
                setFileList([]);
                closeModal();
            })
            .catch(console.log)
            .finally(() => setLoading(false));
    };

    const handleUpload = async () => {
        const formData = new FormData();
        formData.append('file', fileList[0]);

        const { totalRows, estimatedSeconds } = await handleExcelFileRead(fileList[0]);
        setRemainingTime(estimatedSeconds);
        setProgress(0);
        setIsImporting(true);

        let currentProgress = 0;
        const interval = setInterval(() => {
            currentProgress += 100 / estimatedSeconds;
            setProgress(Math.min(Math.round(currentProgress), 100));
            if (currentProgress >= 100) clearInterval(interval);
        }, 1000);

        let countdown = estimatedSeconds;
        const countdownInterval = setInterval(() => {
            countdown -= 1;
            setRemainingTime(countdown);
            if (countdown <= 0) clearInterval(countdownInterval);
        }, 1000);

        postUpload('POST', '/upload/shift', formData).then(() => {
            clearInterval(interval);
            setProgress(100);
            setTimeout(() => setIsImporting(false), 1000);
        }).catch(() => {
            clearInterval(interval);
            setIsImporting(false);
        });
    };

    const onChangeDate = (date, dateString) => {
        setDates(dateString || moment().format('YYYY-MM-DD'));
    };

    return (
        <div>
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Employee Shift</h3>
            <Row>
                <Col span={16}>
                    <DatePicker onChange={onChangeDate} format={'YYYY-MM-DD'} placeholder='Pilih Tanggal' />
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        style={{ marginLeft: 10, width: '40%' }}
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={8} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => setIsModal(true)}>
                        <b style={{ marginLeft: 5 }}>Create Shift</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Form Shift" open={isModal} footer={null} onCancel={closeModal}>
                <div style={{ marginBottom: 20 }}>
                    <h4>Download Template</h4>
                    <p>Choose Date</p>
                    <RangePicker
                        style={{ width: 300, marginBottom: 10 }}
                        onChange={(dates) => setRangeDate(dates)}
                    />
                    <Button
                        type="primary"
                        onClick={() => templateShiftExcel(rangeDate[0], rangeDate[1], users)}
                        style={{ marginBottom: 10, marginLeft: 10 }}
                    >
                        <b>Download</b>
                    </Button>
                </div>
                <Divider />
                <div>
                    <h4>Upload Data Shift</h4>
                    <Row>
                        <Upload {...props} maxCount={1} disabled={loading}>
                            <Button icon={<UploadOutlined />} disabled={loading || fileList.length > 0}>
                                {loading ? 'Uploading...' : 'Import Data Shift'}
                            </Button>
                        </Upload>
                        <Button
                            type="primary"
                            disabled={loading}
                            onClick={() => handleUpload(rangeDate[0], rangeDate[1], users)}
                            style={{ marginBottom: 10, marginLeft: 10 }}
                        >
                            {loading ? <Spin /> : <b>Upload</b>}
                        </Button>
                    </Row>
                    {totalRows > 0 && !isImporting && (
                        <p style={{ marginTop: 15, fontSize: 14, color: '#999' }}>
                            Estimasi waktu proses upload: <b>
                                {Math.floor(remainingTime / 60) > 0
                                    ? `${Math.floor(remainingTime / 60)} menit ${remainingTime % 60} detik`
                                    : `${remainingTime} detik`}
                            </b>
                        </p>
                    )}
                    {isImporting && (
                        <div style={{
                            marginTop: 20,
                            padding: 20,
                            border: '1px solid #d9d9d9',
                            borderRadius: 8,
                            background: '#fafafa',
                            textAlign: 'center',
                            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
                        }}>
                            <h4 style={{ marginBottom: 10, color: '#1890ff' }}>Sedang Mengunggah Data Shift</h4>
                            <Progress
                                percent={progress}
                                status={progress < 100 ? 'active' : 'success'}
                                strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
                            />
                            {remainingTime > 0 && (
                                <p style={{ marginTop: 15, fontSize: 14, color: '#555' }}>
                                    Estimasi waktu tersisa: <b>
                                        {Math.floor(remainingTime / 60) > 0
                                            ? `${Math.floor(remainingTime / 60)} menit ${remainingTime % 60} detik`
                                            : `${remainingTime} detik`}
                                    </b>
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
}

export default UserShift;
